<template>
    <div>
      <SideBar />
      <HeaderData />
      <v-row align="center">
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="9">
              <v-text-field v-model="search" label="Search" style="width: 300px" class="mt-5 ml-4" single-line
                hide-details></v-text-field>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-btn @click="openDialog" class="mt-5 mr-3"  style="height: 40px; width: 110px; margin-right:150px" color="primary" rounded="xl">
                <v-icon left>mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
  
      <v-dialog v-model="dialogVisible" max-width="800px">
        <v-card>
          <v-toolbar color="#0277BD" :style="{ fontSize: '25px', paddingLeft:'20px'}" dark flat>
            {{ formData.id ? "Edit" : " Add" }} Distributor </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
                <v-text-field v-model="formData.name" :rules="nameRules" label="Name" required></v-text-field>
                <v-select
                :key="states.length"
                  v-model="formData.state_id"
                  :items="states"
                  item-title="name"
                  item-value="id"
                  label="State"
                  @update:modelValue="onStateChange"
                  :rules="stateRules"
                  required
                ></v-select>
                <v-select
                    v-model="formData.city_id"
                    :items="cities"
                    item-title="name"
                    item-value="id"
                    label="City"
                    :rules="cityRules"
                    :disabled="!formData.state_id"
                    required
                ></v-select>
                  <v-text-field v-model="formData.address" label="Address" :rules="addressRules" required></v-text-field>
                  <v-text-field v-model="formData.phone_number" label="Phone Number" :rules="phoneNumberRules" required></v-text-field>
              <div class="mt-5 ml-1">
                <!-- <v-switch v-model="formData.isActive" color="primary" inset label="Active" ></v-switch> -->
              </div>
              <!-- <div class="mb-1">
                <span>Description</span>
              </div> 
              <Editor v-model="formData.description" editorStyle="height: 320px" />
              <div v-if="v$.formData.description.$error" class="mt-2 ml-5 error-message">Description is required!</div> -->
            </v-card-text>
            <div class="mx-4">
              <!-- <v-file-input 
                v-model="fileInput"
                :key="fileInputKey"
                accept="image/*" 
                label="Image Input" 
                @change="handleFileUpload"
                ></v-file-input> -->
                <!-- v-model="fileInput" 
                -->

            </div>
            <v-card-actions>
              <v-btn v-if="!isLoading" color="primary" @click="validate">{{
                formData.id ? "Update" : "Save"
              }}</v-btn>
              <span v-if="isLoading" class="mr-2">Please Wait</span> 
              <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>
  
              <v-btn v-if="!isLoading" @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
  
      <v-dialog v-model="confirmDeleteDialogVisible" persistent max-width="400px">
        <v-card>
          <v-card-title class="headline mt-4">Confirm Delete</v-card-title>
          <v-card-text>Are you sure you want to delete this Distributor?</v-card-text>
          <!-- <v-card-text>:Note- Deleting distributor also deleted all related distributors too.</v-card-text> 
          
          -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!isLoading" color="darken-1" text @click="confirmDeleteDialogVisible = false">Cancel</v-btn>
            <v-btn v-if="!isLoading" color="red darken-1" text @click="confirmDelete">Delete</v-btn>
            <span v-if="isLoading" class="mr-2">Please Wait</span> 
            <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirmActiveDialogVisible" persistent max-width="400px">
        <v-card>
          <v-card-title class="headline mt-4">Confirm In-Active Distributor</v-card-title>
          <v-card-text
            >Are you sure you want to inactive this Distributor?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!isLoading"
              color="darken-1"
              text
              @click="cancelActive"
              >Cancel</v-btn
            >
            <v-btn v-if="!isLoading" color="red darken-1" text @click="toggleActiveStatus">In Active</v-btn>
            <span v-if="isLoading" class="mr-2">Please Wait</span> 
            <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-data-table :headers="headers" :items="distributors" class="mt-2">
        <template #bottom>
          <v-pagination v-model="pagination.currentPage" :length="pagination.lastPage" :total-visible="6"
            @input="handlePageChange($event)"></v-pagination>
        </template>
  
        <template v-slot:item.actions="{ item }" >
          <v-icon color="blue" @click="editDistributor(item)">mdi-pencil</v-icon>
          <v-icon class="ml-3" color="red" @click="deleteDistributor(item)">mdi-delete</v-icon>
        </template>
        <!-- <template v-slot:item.isActive="{ item }">
          <v-switch
            v-model="item.isActive"
            @click.prevent="changeActiveValue(item)"
            color="primary"
          ></v-switch>
        </template> -->
      </v-data-table>
    </div>
    <v-snackbar v-model="snackbarVisible" location="top right">
      {{ snackbarMessage }}
    </v-snackbar>
  </template>
  <script>
  import SideBar from "../components/SideBar.vue";
//   import CategoriesDropdown from "@/components/CategoriesDropdown.vue";
  import { mapActions } from "vuex";
  import ConfirmationDialog from "../components/Common/ConfirmationDialog.vue";
  import HeaderData from "@/components/HeaderData.vue";
//   import Editor from "primevue/editor";
  import { required } from '@vuelidate/validators';
  import useVuelidate from '@vuelidate/core';
  import axios from 'axios';
  
  export default {
    components: {
    //   CategoriesDropdown,
      SideBar,
      ConfirmationDialog,
      HeaderData,
    //   Editor,
    },
  
    data() {
      return {
        search: "",
        dialogVisible: false,
        isLoading: false,
        isActiveSwitch: false,
        valid: true,
        name: "",
        nameRules: [(v) => !!v || "Name is required!"],
        stateRules: [(v) => !!v || "State is required!"],
        cityRules: [(v) => !!v || "City is required!"],
        addressRules: [(v) => !!v || "Address is required!"],
        phoneNumberRules: [(v) => !!v || "Phone Number is required!"],
        formData: {
          id: null,
          name: "",
          state_id: null,
          city_id: null,
          address: "",
          phone_number: "",
          isActive: true
        },
        headers: [
          { text: "Name", title: "Name", value: "name", sortable: true },
          {
            text: "State",
            title: "State",
            value: "state_id",
            sortable: true,
          },
          {
            text: "City",
            title: "City",
            value: "city_id",
            sortable: true,
          },
          {
            text: "Address",
            title: "Address",
            value: "address",
            sortable: true,     
          },
          {
            text: "Phone Number",
            title: "Phone Number",
            value: "phone_number",
          },
          //{
           // text: "isActive",
           // title: "Active",
           // value: "isActive",
           // sortable: true,     
          //},
          {
            text: "Actions",
            title: "Actions",
            value: "actions",
            sortable: false,
          },
        ],
        confirmDeleteDialogVisible: false,
        confirmActiveDialogVisible: false,
        // selectedFile: [],
        // selectedImage: [],
        // fileInput: null,
        // fileInputKey: 0,
        // isImageSelected: false,
        // imagesData: [],
        confirmDeleteDialogVisible: false,
        // selectedDistributor: null,
        sortBy: [],
        sortDesc: [],
        snackbarVisible: false,
        snackbarMessage: "",
        pagination: {
          lastPage: null,
          currentPage: 1,
          total: null,
          perPage: 10,
        },
      };
    },
  
    validations() {
      return {
        formData: {
          name: { required },
        }
      }
    },
  
    setup() {
      const v$ = useVuelidate();
      return { v$ };
    },
  
    created() {
      this.fetchDistributors(
        this.pagination.currentPage,
        this.pagination.perPage,
        this.search
      );

      this.fetchStates();
      console.log("this.pagination.currentPage", this.pagination.currentPage);
      console.log("this.pagination.perPage", this.pagination.perPage);
    },
  
    watch: {
      "pagination.currentPage"(newPage) {
        if (typeof newPage !== "undefined") {
          this.fetchDistributors(newPage, this.pagination.perPage, this.search);
        }
      },
  
      search(newSearch, oldSearch) {
        if (newSearch !== oldSearch) {
          this.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.fetchDistributors(
              this.pagination.currentPage,
              this.pagination.perPage,
              newSearch
            );
          });
        }
      },
    },
  
    beforeRouteLeave() {
      this.pagination.currentPage = 1;
    },
  
    computed: {
      distributors() {
        const distributorsData = this.$store.state.distributors;
  
        this.pagination.lastPage = distributorsData.last_page;
        this.pagination.currentPage = distributorsData.current_page;
        this.pagination.perPage = distributorsData.per_page;
        this.pagination.total = distributorsData.total;
        return this.$store.state.distributors.data;
      },

      states() {
                const states = this.$store.state.states;

                const data = states.map((state) => ({
                    id: state.id,
                    name: state.name,
                }));
                return data;
     },
    cities() {
                const cities = this.$store.state.cities;

                const data = cities.map((city) => ({
                    id: city.id,
                    name: city.name,
                }));
                return data;
            },
    },
    methods: {
        ...mapActions([
        'fetchDistributors', 
        'addDistributor', 
        'updateDistributor', 
        'deleteDistributor',
        'fetchStates',
        'fetchCities'
      ]),   
    onStateChange(stateId) {
        if (stateId) {
            this.formData.city_id = null;
            this.fetchCities(stateId);
        } 
    },
    async fetchCities(stateId) {
        await this.$store.dispatch("fetchCities", { state_id: stateId });
    },   
      async fetchDistributors(page, perPage, search) {
        search = search || "";
        await this.$store.dispatch("fetchDistributors", {
          page: page,
          perPage: perPage,
          search: search,
        });
      },
  
      cancelActive() {
        this.confirmActiveDialogVisible = false;
        this.fetchDistributors();
      },
  
      changeActiveValue(item) {
        this.selectedDistributor = item;
        if(item.isActive == true) {
          this.confirmActiveDialogVisible = true;
        } else {
          this.toggleActiveStatus();
        }
      },
      async toggleActiveStatus() {
        let item = this.selectedDistributor;
        this.isLoading = true;
        try {
          let formData = {
            id: item.id,
            isActive: !item.isActive,
          }
          const response = await axios.post(
            `${process.env.VUE_APP_URL}/api/distributor-change-active`,
            formData
          );
          this.fetchDistributors(
            this.pagination.currentPage,
            this.pagination.perPage,
            this.search
          );
          this.confirmActiveDialogVisible = false;
          this.snackbarMessage = "Distributor updated successfully";
          this.snackbarVisible = true;
        } catch (error) {
          this.confirmActiveDialogVisible = false;
          this.isLoading = false;
          console.error("Error toggling distributor active status:", error);
        } finally {
          this.confirmActiveDialogVisible = false;
          this.isLoading = false;
        }
      },
  
      stripTags(htmlString) {
        const doc = new DOMParser().parseFromString(htmlString, "text/html");
        return doc.body.textContent || "";
      },
  
    //   handleDistributorSelected(distributorId) {
    //     console.log("Distributor selected:", distributorId);
    //     this.formData.parentDistributorId = distributorId;
    //     // this.distributorValid = !!selectedDistributor;
    //     // this.checkFormValidity(); 
    //   },
  
    async validate() {
      const validate = await this.$refs.form.validate();
      await this.v$.$validate();
      if (validate.valid && !this.v$.$error) {
        this.saveDistributor();
      }
    },
      openDialog() {
        this.dialogVisible = true;
      },
      closeDialog() {
        this.dialogVisible = false;
        this.formData = {
          id: "",
          name: "",
          state_id: "",
          city_id: "",
          address: "",
          phone_number: "",
          isActive: true,
        //   parentCategoryId: "",
        };
        this.state=[];
        this.cities=[];
        if (this.v$) {
          this.v$.$reset();
        }
      },
      handlePageChange(newPage) {
        this.pagination.currentPage = newPage;
        this.fetchDistributors(
          this.pagination.currentPage,
          this.pagination.perPage,
          this.search
        );
      },
        async saveDistributor() {
            this.isLoading = true;
            let formData = {
                id: this.formData.id,
                name: this.formData.name,
                state_id: this.formData.state_id,
                city_id: this.formData.city_id,
                address: this.formData.address,
                phone_number: this.formData.phone_number,
                isActive: this.formData.isActive,
            };

            if (formData.id) {
                await this.$store.dispatch("updateDistributor", { updatedDistributor: formData });
                this.fetchDistributors(
                    this.pagination.currentPage,
                    this.pagination.perPage,
                    this.search
                );
            } else {
                await this.$store.dispatch("addDistributor", {
                    formData: formData,
                    page: this.pagination.currentPage,
                    perPage: this.pagination.perPage,
                });
            }

            try {
                this.isLoading = false;
                this.snackbarMessage = this.formData.id
                    ? "Distributor updated successfully!"
                    : "Distributor added successfully!";
                this.snackbarVisible = true;
                this.closeDialog();
            } catch (error) {
                this.isLoading = false;
                console.error("Error saving distributor:", error);
                this.snackbarMessage = "Error occurred while saving the distributor.";
                this.snackbarVisible = true;
            }
        },

  
      editDistributor(item) {
        this.formData = {
          id: item.id,
          name: item.name,
          state_id: item.state_id,
          city_id: item.city_id,
          address: item.address,
          phone_number: item.phone_number,
          isActive: item.isActive
        };
        this.dialogVisible = true;
      },
  
      deleteDistributor(item) {
        this.selectedDistributor = item;
        this.confirmDeleteDialogVisible = true;
      },
        async confirmDelete() {
            try {
            this.isLoading = true;
            const distributorId = this.selectedDistributor.id;
            await this.$store.dispatch("deleteDistributor", distributorId);
            // this.$store.commit("DELETE_DISTRIBUTOR", distributorId);
            this.fetchDistributors(
                    this.pagination.currentPage,
                    this.pagination.perPage,
                    this.search
            );  
            this.confirmDeleteDialogVisible = false;
            this.pagination.currentPage = 1;
            this.selectedDistributor = null;
            this.isLoading = false;
            this.snackbarMessage = "Distributor deleted successfully!";
            this.snackbarVisible = true;
            } catch (error) {
            this.isLoading = false;
            console.error("Error deleting distributor:", error);
            this.snackbarMessage = "Error occurred while deleting the distributor.";
            this.snackbarVisible = true;
            }
        },
    },
  };
  </script>
  <style scoped>
  .truncate-text {
    display: inline-block; 
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .error-message {
    font-size: small;
    color: #B00020;
  }
  
  .file-input-label {
    background-color: #f6f6f6;
    /* color: white; */
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: inline-block;
    color: white;
  }
  
  .file-input {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  
  .v-table--density-default {
      --v-table-header-height: 60px;
      --v-table-row-height: 75px;
  }
  </style>
  